import { z } from "zod";
import { customErrorMap, myPreProcess } from "../shared/validation/zod";

z.setErrorMap(customErrorMap);

export const DocumentWorkCustomDataSchema = z.object({

    // required
    id: z.number(),
    business_id: z.number(),
    document_work_id: z.number(),
    field_index: z.number(),

    created_at: z.string(),
    updated_at: z.string(),

    // nullable
    field_value: z.string().nullable(),

});

export const DocumentWorkCustomDataFormSchema = z.object({

    // optional in create
    id: z.number().optional(),
    business_id: z.number().optional(),
    document_work_id: z.number().optional(),

    created_at: z.string().optional(),
    updated_at: z.string().optional(),

    // required
    field_index: z.number(),

    // optional nullable fields
    field_value: z.preprocess((val) => myPreProcess(val), z.string().nullish()),

});

export type DocumentWorkCustomData = z.infer<typeof DocumentWorkCustomDataSchema>
export type DocumentWorkCustomDataForm = z.infer<typeof DocumentWorkCustomDataFormSchema>